import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { DeliveryTariffResource } from "@exonn/js-sdk";

export const module: ModuleOptions<DeliveryTariffResource> = {
  resource: ResourceEnum.DeliveryTariff,
  bigIcon: <span className={"icon-20-deliv_cost"} />,
  smallIcon: <span className={"icon-15-deliv_cost"} />,
};
